import {
  ParametricAssetId,
  SubmittingOrganization,
  type ParametricAsset,
} from "@/types";

type AssetParams = {
  h: number; // Hauteur
  lb: number; // Largeur bas
  lh: number; // Largeur haute
};

const asset: ParametricAsset<AssetParams> = {
  id: ParametricAssetId.TRAPEZOIDAL_PIER,
  image: "/images/assets/pile-trapézoïdale.png",
  submittedBy: SubmittingOrganization.ARS,
  inputs: [
    {
      key: "h",
      type: "dimension",
    },
    {
      key: "lb",
      type: "dimension",
    },
    {
      key: "lh",
      type: "dimension",
    },
  ],
  build: (params, offset) => {
    const { h, lb, lh } = params;
    return [
      {
        type: "polyline",
        points: [
          [offset[0] - lh / 2, offset[1] + h / 2, offset[2]], // Top left
          [offset[0] + lh / 2, offset[1] + h / 2, offset[2]], // Top right
          [offset[0] + lb / 2, offset[1] - h / 2, offset[2]], // Bottom right
          [offset[0] - lb / 2, offset[1] - h / 2, offset[2]], // Bottom right
          [offset[0] - lh / 2, offset[1] + h / 2, offset[2]], // Top left
        ],
      },
    ];
  },
};

export default asset;
